<template>
  <div id="editor" class="col-sm-12">
    <div class="col-sm-12 editor-form nopads">
      <h2 class="editor-header"> {{ permissionUpdate.id > 0 ? $t('work_permission.edit') : $t('work_permission.add') }}</h2>
      <div class="col-sm-12 form-data nopads">
        <h3
          v-if="permissionUpdate.id > 0"
          class="span-title"
        >
          {{ permissionUpdate.requested_by.last_name }}, {{ permissionUpdate.requested_by.first_name }}
        </h3>

        <!-- Contract-->
        <span class="span-title">
          {{ $t('orders.select_contract') }}
        </span>
          <select
            id="contracts"
            v-model="permissionUpdate.contract.id"
            class="form-select form-select-mb"
            :disabled="contracts.length < 1||permissionUpdate.id>0"
          >
              <option
                :value="null"
              >
                {{ $t('orders.select_contract') }}
              </option>
            <option
              v-for="option in contracts"
              :key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>

        <!-- Filter only user created contracts -->
          <div
              v-if="permissionUpdate.id < 1"
              class="ms-1"
          >
              <div class="form-check">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="onlyUserOwnedContracts"
                      v-model="onlyUserOwnedContracts"
                      :value="1"
                      :unchecked-value="0"
                  />
                  <label class="form-check-label" for="onlyUserOwnedContracts">
                      {{ $t('contracts.only_user_owned_contracts') }}
                  </label>
              </div>
          </div>

        <!-- Type-->
        <span class="span-title">
          {{ $t('work_permission.select_type') }}
        </span>
        <select
            id="types"
            v-model="permissionUpdate.type"
            class="form-select form-select-mb"
            :disabled="permissionUpdate.id>0"
          >
              <option
                :value="null"
              >
                {{ $t('work_permission.select_type') }}
              </option>
            <option
              v-for="option in getTypes()"
              :key="option.value"
              :value="option.value"
            >
              {{ option.name }}
            </option>
        </select>

        <!-- Info-->
        <span class="span-title">
          {{ $t('work_permission.info') }}
        </span>
        <input
            id="name"
            v-model="permissionUpdate.info"
            :disabled="permissionUpdate.id>0"
            class="form-control form-control-mb"
            type="text"
        />

        <!-- Type-->
        <div
          v-if="permissionUpdate.id>0 && permissionUpdate.status !== REQUESTED"
          class="col-sm-12 nopads"
        >
          <span class="span-title">
            {{ $t('work_permission.handled_at') }}
          </span>
          <span class="italic">
            {{ toLocalTime(permissionUpdate.handling_time) }}
          </span>
          <span class="span-title">
            {{ $t('work_permission.handled_by') }}
          </span>
          <span class="italic">
            {{ permissionUpdate.handled_by.last_name }}, {{ permissionUpdate.handled_by.first_name }}
          </span>
          <span class="span-title">
            {{ $t('work_permission.handlers_note') }}
          </span>
          <span class="italic">
            {{ permissionUpdate.handlers_note }}
          </span>
        </div>

        <div class="col-sm-12 my-2 d-flex justify-content-end">
            <button
                class="form-button btn btn-secondary"
                @click.stop="$emit('close')"
            >
                {{ $t('common.cancel') }}
            </button>
          <button
            v-if="permissionUpdate.id > 0 && permissionUpdate.status === REQUESTED"
            class="form-button btn btn-primary"
            :disabled="loading"
            @click.stop="handleRequestModal = true"
          >
            {{ $t('work_permission.handle_request') }}
          </button>
            <button
                v-if="permissionUpdate.id<1"
                class="form-button btn btn-success"
                :disabled="loading"
                @click.stop="submitPermissionRequest"
            >
                {{ $t('common.save') }}
            </button>

        </div>
      </div>
    </div>
    <base-modal v-if="handleRequestModal" :hide-footer="true" @close="handleRequestModal = false">
        <div @click.stop="">
            <span>{{ $t('work_time.note') }}</span>
            <input
                id="note-input"
                v-model="handlersNote"
                class="form-control"
            >
            <div class="col-12 d-flex my-2 justify-content-end">
                <button
                    class="btn btn-danger form-button"
                    :disabled="handlersNote===null||handlersNote.trim().length===0"
                    @click.stop="handleRequest(3)"
                >
                    <span>{{ $t('work_permission.reject') }}</span>
                </button>
                <button
                    class="btn btn-success form-button"
                    :disabled="handlersNote===null||handlersNote.trim().length===0"
                    @click.stop="handleRequest(2)"
                >
                    <span>{{ $t('work_permission.accept') }}</span>
                </button>
            </div>
        </div>
    </base-modal>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workPermissionHelper} from '../mixins/WorkPermissionMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {inject} from "vue";
import BaseModal from "@/components/BaseModal.vue";

export default {
    name: 'WorkPermissionEditor',
    components: {BaseModal},
    mixins: [restApi, workPermissionHelper, timeUtils],
    props: {
        workPermission: {
            type: Object,
            default: null
        },
        isObserver: {
            type: Boolean,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            contracts: [],
            permissionUpdate: null,
            handleRequestModal: false,
            handlersNote: null,
            onlyUserOwnedContracts: 0
        }
    },
    watch: {
        onlyUserOwnedContracts: function() {
            this.fetchContracts()
        }
    },
    created: function () {
        this.fetchContracts()
        this.permissionUpdate = this.newWorkPermission(this.workPermission)
    },
    methods: {
        fetchContracts: function () {
            this.loading = true
            let params = {}
            if(parseInt(this.onlyUserOwnedContracts) === 1) {
                params.onlyUserOwnedContracts = 1
            }
            this.restFetchParams(this.contractUrl, params, this.handleResponse)
        },
        handleResponse: function (response) {
            this.contracts = response.data
            this.loading = false
        },
        setDefaultValues: function () {
            let permission = JSON.parse(JSON.stringify(this.permissionUpdate))
            if (!permission.type) {
                this.showAlert(this.$t('work_permission.select_type'))
                return undefined
            }
            if (permission.contract && permission.contract.id) {
                permission.contract = {id: permission.contract.id}
            } else {
                permission.contract = undefined
            }
            return permission
        },
        submitPermissionRequest: function () {
            let permissionRequest = this.setDefaultValues()
            if (permissionRequest) {
                this.loading = true
                this.restAdd(this.workPermissionUrl, permissionRequest, this.updateSuccess,
                    this.updateFail)
            }
        },
        updateSuccess: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },
        updateFail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },
        handleRequest: function (status) {
            this.loading = true
            this.handleRequestModal = false
            this.restUpdate(this.workPermissionUrl + '/' + this.permissionUpdate.id,
                {status: status, note: this.handlersNote},
                this.updateSuccess, this.updateFail)
        }
    }
}
</script>
